import { defineComponent } from 'vue';
export default defineComponent({
    name: 'CatalogItem',
    events: ['add-to-cart', 'view-details', 'add-to-wishlist'],
    props: {
        host: {
            type: String,
            required: true,
        },
        productPermalink: {
            type: String,
            required: true,
        },
        product: {
            type: Object,
            required: true,
        },
        showAddToCartBtn: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            selectedId: this.product.id,
        };
    },
    computed: {
        // ETHOS
        badgeUrl() {
            if (this.product.taxonomies === undefined)
                return undefined;
            if (this.product.taxonomies['selection_taxonomy'] === undefined)
                return undefined;
            if (this.product.taxonomies['selection_taxonomy'].length === 0)
                return undefined;
            for (const selection of this.product.taxonomies['selection_taxonomy']) {
                if (selection.badge === undefined) {
                    continue;
                }
                return selection.badge.link;
            }
            return undefined;
        },
        // ETHOS
        brand() {
            return this.product.taxonomies?.['product_brand']?.[0]?.name ?? '';
        },
        collection() {
            return this.product.taxonomies?.['product_collection']?.[0]?.name ?? '';
        },
        category() {
            let cat = this.product.taxonomies?.['product_cat']?.[0];
            if (cat === undefined) {
                return '';
            }
            while (cat.children.length !== 0) {
                cat = cat.children[0];
            }
            return cat.name;
        },
        productType() {
            return this.product.taxonomies?.['product_type']?.[0]?.slug ?? '';
        },
        attributeList() {
            const list = this.product?.metadata?.['_attribute_list'] ?? undefined;
            if (list === undefined) {
                return undefined;
            }
            if (Array.isArray(list)) {
                return undefined;
            }
            return JSON.parse(list);
        },
        image() {
            return this.product.image?.sizes['woocommerce_thumbnail']?.link ??
                this.product.image?.sizes['shop_catalog']?.link ??
                this.product.image?.link;
        },
        sku() {
            const sku = this.product?.metadata?.['_sku'] ?? '';
            if (Array.isArray(sku)) {
                return '';
            }
            return sku.replace(/_$/, '');
        },
        price() {
            //return this.taxPrice(this.product.price);
            return this.product.price;
        },
        basePrice() {
            //return this.taxPrice(this.product.basePrice);
            return this.product.basePrice;
        },
        minPrice() {
            //return this.taxPrice(this.product.minPrice);
            return this.product.minPrice;
        },
        starRating() {
            return Number(this.product?.metadata?.['_wc_average_rating'] ?? '0');
        },
        hasStarRating() {
            return this.starRating > 0;
        },
        ratingStarClasses() {
            let classes = [];
            for (let i = 1; i <= 5; i++) {
                if (i <= this.starRating) {
                    classes.push('fas fa-star');
                }
                else if (i <= this.starRating + 0.5) {
                    classes.push('fas fa-star-half-alt');
                }
                else {
                    classes.push('far fa-star');
                }
            }
            return classes;
        },
        salePercentage() {
            if (this.product.onSale) {
                let reg = 0;
                let curr = 0;
                if (this.product.hasPriceRange) {
                    reg = Number(this.product.minBasePrice.replace(',', '.'));
                    curr = Number(this.product.minPrice.replace(',', '.'));
                }
                else {
                    reg = Number(this.product.basePrice.replace(',', '.'));
                    curr = Number(this.product.price.replace(',', '.'));
                }
                return Math.round(100 - (curr * 100) / reg).toString();
            }
            return '';
        },
        jvmWishListExists() {
            return typeof JVMWooCommerceWishlist === 'object';
        },
    },
    methods: {
        taxPrice(price) {
            let taxValue = 0;
            const tax = this.product?.metadata?.['_tax_class'] ?? '';
            if (tax.length === 0 || tax === 'Standard') {
                taxValue = 1.22;
            }
            else {
                taxValue = 1.1;
            }
            const priceTaxed = Number(price ?? 0) * Number(taxValue);
            return (Math.round(priceTaxed * 100) / 100).toFixed(2);
        },
    },
    mounted() {
        if (this.jvmWishListExists) {
            JVMWooCommerceWishlist.build();
        }
        if (this.productType === 'variable' && this.attributeList !== undefined) {
            for (const v of this.attributeList.variations) {
                if (v.stockStatus === 'instock') {
                    this.selectedId = v.variation.toString();
                    break;
                }
            }
        }
    },
});
